import React, { Component } from 'react';
import Lottie from "lottie-react";
import { Button } from 'react-bootstrap';
import booster from '../../assets/img/people/booster.svg'
import filter from '../../assets/img/people/filter.svg'
import location from '../../assets/json/location.json'
import Filter from '../commoncomponents/filter';
import Location from '../commoncomponents/location';
import BoostPlan from '../commoncomponents/boostplan';
import ls from "local-storage";
import axios from 'axios';
import Join from './plan/join';
import revert from '../../assets/img/revert.svg';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Nofind extends Component {

  constructor(props) {
    super(props);
    this.resetusers = this.resetusers.bind(this);
    this.state = {
      filtermodal: false,
      locationmodal:false,
      boostplanmodal:false,
      premiummodal: false,
      user_details: '',
      langKey: ls.get('LangValue'),
      api_url: localStorage.getItem('api_url'),
    };
  }

  componentDidMount() {
    if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
      document.body.dir = 'rtl';
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr')
    } else {
        document.body.dir = 'ltr';
        document.body.classList.remove('rtl');
        document.body.classList.add('ltr');
    }

    var date = new Date();
    var details = new FormData();
    details.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
    details.append('language', this.state.langKey);                
    details.append('timestamp', date.getTime());
    axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
    axios({
      method: 'post',
      url: this.state.api_url+'webgetpeople',
      data: details,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
    }).then(res => {
      if(res.data.status !== "false"){
        this.props.history.push("/find");
      }
    });

    let data = new FormData();
    data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
    data.append('language', this.state.langKey);
    axios({
        method: 'post',
        url: this.state.api_url+'webprofile',
        data: data, 
        config: { headers: {'Content-Type': 'multipart/form-data' }}
    }).then(res => {
        if(res.data.status !== false) {
            const user_details = res.data.result;
            this.setState({
                user_details: user_details
            });
        }
    });
  }

  handleFilterOpenModal = () => {
    localStorage.setItem('seleted_filterreligion', "");
    localStorage.setItem('selected_filterlanguage', "");
    this.setState({ filtermodal: true });
  }

  handleFilterCloseModal = () => {
    this.setState({ filtermodal: false });
  }

  handleLocationOpenModal = () => {
    if(this.state.user_details.premium_member == "true"){
      this.setState({ locationmodal: true });
    }else{
      this.setState({ premiummodal: true });
    }
  }

  handleLocationCloseModal = () => {
    this.setState({ locationmodal: false });
  }

  handlePremiumCloseModal = () => {
    this.setState({ premiummodal: false });
  }

  handleBoostPlanOpenModal = () => {
    this.setState({ boostplanmodal: true });
  }

  handleBoostPlanCloseModal = () => {
    this.setState({ boostplanmodal: false });
  }

  resetusers(){
    let errors = {};
    var payment = new FormData();
    payment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
    axios({
      method: 'post', 
      url: this.state.api_url+'resetusers',
      data: payment, 
      config: { headers: {'Content-Type': 'multipart/form-data' }}
    }).then(res => {
        if (res.data.status === "true") {
            this.setState({
                successMessage: 'Reset done successfully',
                suc_cls: 'successMsg floatingAlerts1'
            });
            setTimeout(() => {
                this.setState({
                    suc_cls: 'successMsghide'
                });
                window.location.reload();
            }, 2000);
        }else{
            this.setState({
                successMessage: 'No dislike users found',
                suc_cls: 'errorMsg floatingAlerts1'
            });
            setTimeout(() => {
                this.setState({
                    suc_cls: 'errorMsghide'
                });
                window.location.reload();
            }, 2000);
        }
    });
}

  render() {

    return (
      <>
        <section className='common_layout'>
          <div className='header_layout'>
            <div className='header_img'>
              <img src={booster} onClick={this.handleBoostPlanOpenModal} alt="img" />
              {this.state.user_details.premium_member === 'true' && this.state.user_details.totalresets > 0 && this.state.user_details.plan_type !== "Kaba Slver" && (
                  <img src={revert} alt="img" onClick={this.resetusers} className='revert_image' />
              )}
            </div>
            <div className='header_title'>
              {localStorage.getItem('filter_page') === '2' ? <h4><Trans i18nKey="Find New People">Find New People</Trans></h4> : <h4><Trans i18nKey="People Near You">People Near You</Trans></h4>}
            </div>
            <div className='header_img' onClick={this.handleFilterOpenModal}>
              <img src={filter} alt="img" className='filter_img'/>
            </div>
          </div>
          {this.state.successMessage && (
              <div className='whole_information'>
                  <div className={this.state.suc_cls}>
                      {this.state.successMessage}
                  </div>
              </div>
          )}
          <div>
            <div className='lottie_height'>
              <Lottie animationData={location} className='lottie_player' />
            </div>
            <div className='common_para'>
              <p><Trans i18nKey="No people in your location">No people in your location</Trans></p>
            </div>
            <div className="find_button_div">
              <Button className='button_primary ' onClick={this.handleLocationOpenModal}>
              <Trans i18nKey="CHANGE LOCATION">CHANGE LOCATION</Trans>
              </Button>
            </div>
          </div>
        </section>
        <Filter
          showModal={this.state.filtermodal}
          handleClose={this.handleFilterCloseModal}
        />
        <Location
          showModal={this.state.locationmodal}
          handleClose={this.handleLocationCloseModal}
        />
        <BoostPlan
          showModal={this.state.boostplanmodal}
          handleClose={this.handleBoostPlanCloseModal}
        />
        <Join
            showModal={this.state.premiummodal}
            handleClose={this.handlePremiumCloseModal}
        />
      </>
    );
  }
}

export default withTranslation("translations")(Nofind);
